class NavigationScroll {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.viewport = wrapper.querySelector('[data-nav-scroll-viewport]');
    this.list = wrapper.querySelector('[data-nav-scroll-target]');
    this.prev = wrapper.querySelector('[data-nav-scroll="prev"]');
    this.next = wrapper.querySelector('[data-nav-scroll="next"]');

    if (!this.viewport || !this.list) return;

    this.bindEvents();
    this.update();
  }

  bindEvents() {
    this.prev?.addEventListener('click', () => this.scroll(-1));
    this.next?.addEventListener('click', () => this.scroll(1));
    this.viewport.addEventListener('scroll', () => this.update());
    window.addEventListener('resize', this.debouncedUpdate.bind(this));

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.list);
    }
  }

  scroll(direction = 1) {
    const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    const current = this.viewport.scrollLeft;
    const step = this.viewport.clientWidth * 0.8; // scroll roughly one view at a time
    const target = Math.min(maxScroll, Math.max(0, current + direction * step));
    this.viewport.scrollTo({ left: target, behavior: 'smooth' });
  }

  debouncedUpdate() {
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => this.update(), 150);
  }

  update() {
    const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    if (this.viewport.scrollLeft > maxScroll) {
      this.viewport.scrollLeft = maxScroll;
    }
    const currentScroll = this.viewport.scrollLeft;

    const isScrollable = maxScroll > 5;
    const viewportRect = this.viewport.getBoundingClientRect();
    const firstItem = this.list.querySelector('[data-aid="navigation-list-item"]');
    const lastItem = this.list.querySelector('[data-aid="navigation-list-item"]:last-child');

    const leftHidden = firstItem ? firstItem.getBoundingClientRect().left < viewportRect.left - 2 : false;
    const rightHidden = lastItem ? lastItem.getBoundingClientRect().right > viewportRect.right + 2 : false;

    if (this.prev) {
      const showPrev = isScrollable && currentScroll > 1;
      this.prev.disabled = !showPrev;
      this.prev.classList.toggle('navigation-scroll__control--visible', showPrev);
    }

    if (this.next) {
      const showNext = isScrollable && currentScroll < maxScroll - 1;
      this.next.disabled = !showNext;
      this.next.classList.toggle('navigation-scroll__control--visible', showNext);
    }

    this.list.classList.toggle('navigation-scroll__list--scrollable', isScrollable);
  }
}

function initNavigationScroll() {
  document.querySelectorAll('[data-nav-scroll-wrapper]').forEach((wrapper) => {
    if (wrapper.__navScrollInitialized) return;
    wrapper.__navScrollInitialized = true;
    new NavigationScroll(wrapper);
  });
}

document.addEventListener('DOMContentLoaded', initNavigationScroll);
document.addEventListener('shopify:section:load', (event) => {
  if (!event || !event.detail || !event.detail.sectionId) return;
  initNavigationScroll();
});
